import { Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const PageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh"
}));

export const RootContainer = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
  width: "100%"
}));

export const ErrorModal = styled(Box)(({ theme }) => ({
  background: alpha(theme.customColors.backgroundPrimary, 0.95),
  border: `${theme.spacing(0.4)} solid #F43E63`,
  boxShadow: `0 0 1rem 0rem ${alpha("#F43E63", 0.95)}, 0 0 2rem 0.25rem ${alpha("#1B1B1B", 0.95)}`,
  backdropFilter: "blur(20px)",
  backgroundColor: alpha("#FFFFFF", 0.1),
  borderRadius: theme.spacing(1),
  height: "fit-content",
  padding: "1rem 2.5rem 1.5rem 2.5rem",
  maxWidth: "600px",

  [theme.breakpoints.down("sm")]: {
    padding: "1rem 1.5rem 1.5rem 1.5rem",
    maxWidth: "80vw"
  }
}));
